import React, { ReactElement, useState } from 'react';
import * as UI from 'components/ui/EventBrief/HostedEventBrief';
import { ConfirmationModal } from 'components/ui';
import { useEventsApi } from 'services/api';

export interface HostedEventBriefProps
  extends Omit<
    UI.HostedEventBriefProps,
    'onClickCancel' | 'onClickDownloadAttendees'
  > {
  onCancel: () => void;
}

export const HostedEventBrief = ({
  onCancel,
  ...props
}: HostedEventBriefProps): ReactElement => {
  const [isCancelModalOpen, setCancelModalOpen] = useState(false);

  const eventsApi = useEventsApi();

  const handleCancelEvent = async () => {
    setCancelModalOpen(false);
    await eventsApi.cancelEvent(props.id);
    onCancel?.();
  };

  return (
    <>
      <UI.HostedEventBrief
        onClickCancel={() => setCancelModalOpen(true)}
        {...props}
      />
      <ConfirmationModal
        open={isCancelModalOpen}
        title="Confirm Cancel Event Request"
        cancelAction="Close"
        confirmAction="Cancel Event"
        onCancel={() => setCancelModalOpen(false)}
        onConfirm={handleCancelEvent}
        message="Once this event is cancelled, it cannot be undone and attendees will be notified."
      />
    </>
  );
};
